import axios from "axios"
import { errorFormatter, successFormatter } from './Formatter.js'

let baseUrlKeys = {
  localhost:"http://localhost:3334",
  messages:"https://pv13b40vbpsjtjn1ey3e2i4xg84s.composersoftware.com"
}

export const requester = (urlkey='localhost') => {
  if(!baseUrlKeys[urlkey]){
    throw new Error(`did not setup url for key: ${urlkey}`);
  }
  let newf = (path) => (config) => {
    config.baseURL = baseUrlKeys[urlkey];
    config.url = path
    return axios(config);
  }
  newf.baseUrl = baseUrlKeys[urlkey];
  return newf
}

export const defaultConfig = () => ({
  method:"GET",
  headers:{
    "Content-Type":"application/x-www-form-urlencoded"
  },
  body:""
})


export const Documents = function(path,rp,emitter){
  this.path = path
  this.responseProperty = rp === undefined ? this.path : rp;
  this.emitter = emitter === undefined ? this.path : emitter;

  this.checkResponseData = function(r){
    if(r !== undefined && r.data && r.data.status && r.data.status >= 400){
      document.Error(errorFormatter(r))
    } else if(r !== undefined){
      document.Success(successFormatter(r))
    }
    return r;
  }
  
  this.set = function(response){
    if(response.data[this.responseProperty]){
      localStorage.setItem(this.path, JSON.stringify(response.data[this.responseProperty])); 
    }
    return response;
  }

  this.get = function(id={}){
    //this.checkResponseData(response)
    let pathext = "";
    let jwtaccess = localStorage.getItem("ACCESS_TOKEN");
    let options = defaultConfig();
    options.method = "GET";
    options.headers['Content-Type'] = "application/json";
    options.headers['Authorization'] = `Bearer ${jwtaccess}`;

    if(typeof(id) === "string"){
      pathext = `/${this.path}/${id}`
    }
    if(typeof(id) === "object" && id !== null){
      options.headers.query = JSON.stringify(id) 
      pathext = `/${this.path}`
    }
    let service = document.authRequest(pathext);

    return service(options)
      .then(this.set.bind(this))
      .then(document.Success)
      .then(document.requestObserver.emit(this.emitter))
      .catch(document.Error)
  }

  this.post = function(data){
    let jwtaccess = localStorage.getItem("ACCESS_TOKEN");
    let postService = document.authRequest(`/${this.path}`);
    let options = defaultConfig();
    options.method = "POST";
    options.headers['Content-Type'] = "application/json";
    options.headers['Authorization'] = `Bearer ${jwtaccess}`;
    options.data = JSON.stringify(data)
    return postService(options)
      .then(document.Success)
      .then(this.get.bind(this))
      .catch(document.Error)
  }

  this.patch= function(id, data){
    let jwtaccess = localStorage.getItem("ACCESS_TOKEN");
    let options = defaultConfig();
    let pathext = "";
    options.method = "PATCH";
    options.headers['Content-Type'] = "application/json";
    options.headers['Authorization'] = `Bearer ${jwtaccess}`;
    options.data = JSON.stringify([data]);
    if(typeof(id) === "string"){
      pathext = `/${this.path}/${id}`
    }
    if(typeof(id) === "object" && id !== null){
      options.headers.query = JSON.stringify(id) 
      pathext = `/${this.path}`
    }

    let patchOne = document.authRequest(pathext);
    return patchOne(options)
      .then(document.Success)
      .then(this.get.bind(this))
      .catch(document.Error)
  }

  this.delete= function(id){
    let jwtaccess = localStorage.getItem("ACCESS_TOKEN");
    let options = defaultConfig();
    let pathext = "";
    options.method = "DELETE";
    options.headers['Content-Type'] = "application/json";
    options.headers['Authorization'] = `Bearer ${jwtaccess}`;
    if(typeof(id) === "string"){
      pathext = `/${this.path}/${id}`
    }
    if(typeof(id) === "object" && id !== null){
      options.headers.query = JSON.stringify(id) 
      pathext = `/${this.path}`
    }


    let deleteOne = document.authRequest(pathext);
    return deleteOne(options)
      .then(document.Success)
      .then(this.get.bind(this))
      .catch(document.Error)
  }
}

